module.exports = __webpack_public_path__ + "static/media/terms-conditions.08a96b5e.png";